import { decodeOAuthState } from './oauthState';

/** Tenant used when nothing else identifies one. */
export const defaultTenantId = 'DEMO';

/**
 * Works out which tenant an unmatched URL belongs to, in priority order:
 *
 * 1. the tenant carried in the OAuth `state` parameter of a federated callback,
 * 2. the tenant selected earlier in this browser session,
 * 3. the default tenant.
 *
 * `state` takes priority because sessionStorage can be dropped across the Cognito round-trip,
 * which used to land SSO users on the default (OTP) tenant and fail with an "incorrect login
 * method" error (HRI2-16956). The session fallback is kept for callbacks issued before `state`
 * existed and for non-OAuth navigation, where it cannot cause that bug any more.
 *
 * This only decodes `state` - it never consumes the single-use nonce, because routing may run
 * more than once. Verification happens in `submitAuthCode`.
 */
export function resolveCallbackTenantId({
  code,
  state,
  storedTenantId,
}: {
  code: string | null | undefined;
  state: string | null | undefined;
  storedTenantId: string | null | undefined;
}): string {
  const tenantIdFromState = code ? decodeOAuthState(state)?.tenantId : null;
  return tenantIdFromState ?? storedTenantId ?? defaultTenantId;
}
